import { fromJS, Map } from 'immutable';

import ProductRecord from 'records/product';
import { mapProduct } from 'utils/mapToRecord';
import { createSymbols } from 'utils/helpers';
import { resourceReducer } from 'utils/reducerGenerator';

export const {
    EDIT_IN_PRODUCT,
    FETCH_SINGLE_PRODUCT,
    FETCH_SINGLE_PRODUCT_SUCCESS,
    FETCH_SINGLE_PRODUCT_FAIL,
    PATCH_PRODUCT,
    PATCH_PRODUCT_SUCCESS,
    PATCH_PRODUCT_FAIL,
    RESET_PRODUCT,
    SET_PRODUCT,
    TOGGLE_CREATE_PRODUCT_DIALOG,
} = createSymbols([
    'EDIT_IN_PRODUCT',
    'FETCH_SINGLE_PRODUCT',
    'FETCH_SINGLE_PRODUCT_SUCCESS',
    'FETCH_SINGLE_PRODUCT_FAIL',
    'PATCH_PRODUCT',
    'PATCH_PRODUCT_SUCCESS',
    'PATCH_PRODUCT_FAIL',
    'RESET_PRODUCT',
    'SET_PRODUCT',
    'TOGGLE_CREATE_PRODUCT_DIALOG',
]);

const editInProduct = (state, { path, value }) => state.setIn(path, value);
const fetchProduct = (state) => state.set('isFetching', true);
const fetchProductFinished = (state) => {
    return state.set('isFetching', false).set('hasFetched', true);
};
const fetchProductSuccess = (state, { payload }) => {
    const updatedState = fetchProductFinished(state);
    return updatedState
        .set('lastFetched', Date.now())
        .set('data', mapProduct(
            fromJS(payload.data)
        ));
};
const patchProduct = (state) => state;
const patchProductFail = (state) => state;
const patchProductSuccess = (state, { payload }) => {
    return state.set('data', mapProduct(fromJS(payload.data)));
};
const resetProduct = (state) => state.set('data', ProductRecord(Map({})));
const setProduct = (state, { product }) => state.set('data', ProductRecord(product));
const toggleProductDialog = (state) => state.set('dialogOpen', !state.get('dialogOpen'));

export const { reducer, types } = resourceReducer(
    {
        namespace: 'PRODUCT',
        transformer: mapProduct,
    },
    {
        [EDIT_IN_PRODUCT]: editInProduct,
        [FETCH_SINGLE_PRODUCT]: fetchProduct,
        [FETCH_SINGLE_PRODUCT_FAIL]: fetchProductFinished,
        [FETCH_SINGLE_PRODUCT_SUCCESS]: fetchProductSuccess,
        [PATCH_PRODUCT]: patchProduct,
        [PATCH_PRODUCT_FAIL]: patchProductFail,
        [PATCH_PRODUCT_SUCCESS]: patchProductSuccess,
        [RESET_PRODUCT]: resetProduct,
        [SET_PRODUCT]: setProduct,
        [TOGGLE_CREATE_PRODUCT_DIALOG]: toggleProductDialog,
    }
);

export default reducer;
